export default __webpack_public_path__ + "static/media/3.fde567c1.png";